// actions
import { ERRORMSG_HYDRATE_ERRORS, ERRORMSG_CREATE_ERROR, ERRORMSG_DELETE_ERROR } from './actions';

const ErrorMsg = (state = {
  error: false,
  errorMsg: '',
  errors: {
    invalidAddress: '',
    invalidTrip: '',
    errorSuggestion: '',
    somethingWrong: '',
  },
}, action) => {
  switch (action.type) {
    case ERRORMSG_HYDRATE_ERRORS:
      return {
        ...state,
        errors: {
          ...action.data.errors,
        },
      };
    case ERRORMSG_CREATE_ERROR:
      return {
        ...state,
        error: true,
        errorMsg: action.errorMsg,
      };
    case ERRORMSG_DELETE_ERROR:
      return {
        ...state,
        error: false,
        errorMsg: '',
      };
    default:
      return state;
  }
};

export default ErrorMsg;
